import styled from 'styled-components';
import * as DropdownMenu from '@radix-ui/react-dropdown-menu';
import { zIndex } from 'tokens';

// Matches Widget/Button/Button PRIMARY + MEDIUM size.
export const Trigger = styled(DropdownMenu.Trigger)`
	display: inline-flex;
	align-items: center;
	justify-content: center;
	gap: 6px;
	min-width: 60px;
	height: 32px;
	padding: 0 12px;
	border-radius: 20px;
	border: 1px solid transparent;
	background: ${({ theme }) => theme.gray[1000]};
	color: ${({ theme }) => theme.gray[0]};
	font-size: 12px;
	font-weight: 500;
	line-height: 31px;
	user-select: none;

	&:hover {
		background: ${({ theme }) => theme.gray[700]};
	}
	&:active {
		background: ${({ theme }) => theme.gray[400]};
	}
`;

export const Chevron = styled.span<{ $open: boolean }>`
	display: inline-flex;
	align-items: center;
	transition: transform 0.2s ease;
	transform: rotate(${({ $open }) => ($open ? '180deg' : '0deg')});
`;

export const Content = styled(DropdownMenu.Content)`
	z-index: ${zIndex.contextMenu};
	background: ${({ theme }) => theme.gray[100]};
	border: 1px solid ${({ theme }) => theme.gray[400]};
	border-radius: 10px;
	box-shadow: 0 8px 24px rgba(0, 0, 0, 0.12), 0 0 1px rgba(0, 0, 0, 0.12);
	padding: 4px;
	min-width: 240px;
	overflow: hidden;
`;
